import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsChatPage } from "./redux/sessionSlice"; // adjust path
import "./App.css";
import "./css/variables.css";
import "./css/extra.css";
// Layouts
import MainLayout from "./components/MainLayout1";
import AuthLayout from "./components/AuthLayout";
import SuperAdminLayout from "./superadmin/SuperAdminLayout";
import AdminLayout from "./Admin/AdminLayout";

// Protected Routes
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import Home from "./pages/Home";
import Login from "./auth/Login";
import SendEmail from "./auth/SendEmail";
import VerifyEmail from "./auth/VerifyEmail";
import ResetPassword from "./auth/ResetPassword";
import ChatPage from "./pages/ChatPage";
import SwitchTab from "./pages/SwitchTabPage";
import ImageToDesciption from "./pages/ImageToDescriptionPage";
import ImageToVideo from "./pages/ImageToVideo";
import AudioToText from "./pages/AudioToText";
import PdfToAll from "./pages/PdfToAll";
import AudioToAudio from "./pages/AudioToAudio";
import AudioToChat from "./pages/AudioToChat";
import Enterprize from "./pages/EnterPrise";
import Enterprise1 from "./Admin/EnterPrise";
import ActivityLog from "./pages/ActivityLog";
import PerformanceLog from "./pages/PerformanceLog";
import RoleManagement from "./pages/RoleManagement";
import ModuleManagement from "./superadmin/ModuleMangement";
import UserManagement from "./superadmin/UserManagement";
import UserManagement1 from "./Admin/UserManagement";
import PageTitleUpdater from "./components/PageTitleUpdater";
import ChatSharedPage from "./users/ChatSharedPage";
import TrainDocument from "./users/TrainDocument";
import UserKnowledgeRepository from "./users/DocumentHistory/DocumentHistory";
import UserUrlsHistory from "./users/DocumentHistory/UrlsHistory";
import UserYoutubeHistory from "./users/DocumentHistory/YoutubeHistory";
import UserTextHistory from "./users/DocumentHistory/TextHistory";
import UserQAHistory from "./users/DocumentHistory/Q&AHistory";
import UserDeleteDocHistory from "./users/DocumentHistory/DeleteDocHistory";

//superadmin knowledge repository
import SuperadminKnowledgeRepository from "./superadmin/DocumentHistory/DocumentHistory";
import SuperadminUrlsHistory from "./superadmin/DocumentHistory/UrlsHistory";
import SuperadminYoutubeHistory from "./superadmin/DocumentHistory/YoutubeHistory";

// Styles
import "./css/SidebarItem.css";
import "./css/Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ComingSoon from "./auth/ComingSoon";
import Notifications from "./users/Notifications";
import ModelManagement from "./superadmin/Modelmanagement";
import Models from "./superadmin/Models";

import "./App.css";
import ProductManagement from "./superadmin/ProductManagement";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ChatStreamProvider } from "./contexts/ChatStreamContext";
import EnterpriseSettings from "./superadmin/EnterpriseSettings";
import EnterpriseSettings1 from "./Admin/EnterpriseSettings";
import SubscriptionManagement from "./superadmin/SubscriptionManagement";
import Dashboard from "./superadmin/Dashboard";
import SuccessfulReset from "./auth/Successful";
import TrainingFiles from "../src/Admin/Training/TrainingFiles";
import TrainingText from "../src/Admin/Training/TrainingText";
import TrainingWebsite from "../src/Admin/Training/TrainingWebsite";
import TrainingQA from "../src/Admin/Training/TrainingQA";
import TrainingYoutube from "../src/Admin/Training/TrainingYoutube";
import ConversationManagement from "./superadmin/ConversationManagement";
import ChatUsageManagement from "./superadmin/ChatUsageManagement";
import UserSessionManagement from "./superadmin/UserSessionManagement";
import ChatUsageManagement1 from "./Admin/ChatUsageManagement";
import UserSessionManagement1 from "./Admin/UserSessionManagement";
import ConversationManagement1 from "./Admin/ConversationManagement";
import ViewConversation from "./superadmin/ViewConversation";
import UploadedDocs from "./Admin/UploadedDocuments/UploadedDocs";
import DocumentHistory from "./Admin/UploadedDocuments/TrainingHistory/DocumentHistory";
import UrlsHistory from "./Admin/UploadedDocuments/TrainingHistory/UrlsHistory";
import TextHistory from "./Admin/UploadedDocuments/TrainingHistory/TextHistory";
import QAHistory from "./Admin/UploadedDocuments/TrainingHistory/Q&AHistory";
import YoutubeHistory from "./Admin/UploadedDocuments/TrainingHistory/YoutubeHistory";
import RepositoryManage from "./Admin/RepositoryMangement/RepositorySpace";
import DocumentChatPage from "./pages/DocumentChatPage";
import UserProfileSettings from "./pages/Profile";
import NotFoundPage from "./pages/NotFoundPage";
import OneDriveFileManager from "./pages/OneDriveFileManager";
import HelpPage from "./pages/HelpPage";
import PrimiumpPage from "./pages/PrimiumPage";
import ErrorLog from "./pages/ErrorLog";
import Unauthorized from "./pages/Unauthorized";
import VersionHistory from "./pages/VersionHistory";
import PDFToAll from "./pages/PdfToAll";
import DocumentUpload from "./users/UploadFiles/DocumentUpload";
import UploadedDocsFiles from "./users/UploadFiles/DocumentsStatus/UploadedDocsFiles";
import SaveDocsFiles from "./users/UploadFiles/DocumentsStatus/SaveDocsFiles";
import DeletedDocsFiles from "./users/UploadFiles/DocumentsStatus/DeletedDocsFiles";
import RecentlyDocsFiles from "./users/UploadFiles/DocumentsStatus/RecentlyDocsFiles";
import TermsAndConditions from "./auth/TermsAndConditions";
import GetHelpInfo from "./users/GetHelpInfo";
import RepoOrganizer from "./modules/repo-organizer/RepoOrganizer";


import GlobalLoader from "./components/GlobalLoader";
import DepartmentManagement from "./superadmin/DepartmentManagement";
import ApiManagement from "./superadmin/ApiManagement";

const AppRoutes = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  // useEffect(() => {
  //   // ✅ Detect if current route is any of your chat routes
  //   const isChatRoute =
  //     // location.pathname.includes("/user/new") ||
  //     location.pathname.includes("/user/newchat") ||
  //     location.pathname.includes("/user/chat/document");

  //   // ✅ Update redux state
  //   dispatch(setIsChatPage(isChatRoute));
  // }, [location, dispatch]);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);
    const handleForceOffline = () => setIsOffline(true);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    // 🔥 From Axios
    window.addEventListener("force-offline", handleForceOffline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("force-offline", handleForceOffline);
    };
  }, []);

  return (
    <>
      <PageTitleUpdater />
      <GlobalLoader />
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<SendEmail />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/successful" element={<SuccessfulReset />} />
          <Route path="/terms" element={<TermsAndConditions />} />
        </Route>

        <Route
          path="/user"
          element={
            <ProtectedRoute allowedRoles={["User"]}>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="new" element={<Home />} />
          <Route path="new/:session_id" element={<ChatPage />} />
          <Route path="chat/document" element={<DocumentChatPage />} />
          <Route path="chat" element={<SwitchTab />} />
          <Route path="newchat" element={<ChatPage />} />
          <Route path="imagetotext" element={<ImageToDesciption />} />
          <Route path="imagetovideo" element={<ImageToVideo />} />
          <Route path="audiototext" element={<AudioToText />} />
          <Route path="audiotoaudio" element={<AudioToAudio />} />
          <Route path="audiotochat" element={<AudioToChat />} />
          <Route path="pdftoall" element={<PdfToAll />} />
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="train-docs" element={<TrainDocument />} />
          <Route path="getHelpPageInfo" element={<GetHelpInfo />} />
          <Route
            path="knowledge-repository"
            element={<UserKnowledgeRepository />}
          />
          <Route
            path="knowledgerepository-weburls"
            element={<UserUrlsHistory />}
          />
          <Route
            path="knowledgerepository-videourls"
            element={<UserYoutubeHistory />}
          />
          <Route
            path="knowledgerepository-deletedocs"
            element={<UserDeleteDocHistory />}
          />
          <Route
            path="knowledgerepository-texthistory"
            element={<UserTextHistory />}
          />
          <Route
            path="knowledgerepository-qahistory"
            element={<UserQAHistory />}
          />
          <Route path="profile" element={<UserProfileSettings />} />
          <Route path="getHelpPage" element={<HelpPage />} />
          <Route path="pdf-to-all" element={<PDFToAll />} />
          <Route path="training-studio" element={<DocumentUpload />} />
          <Route path="knowledgespace-docs" element={<UploadedDocsFiles />} />
          <Route path="personal-space" element={<SaveDocsFiles />} />
          <Route path="knowledgespace-deleted" element={<DeletedDocsFiles />} />
          <Route path="knowledgespace-recent" element={<RecentlyDocsFiles />} />
          <Route path="repo-organizer" element={<RepoOrganizer role="user" />} />


          <Route path="*" element={<ComingSoon />} />
        </Route>

        <Route
          path="/superadmin"
          element={
            <ProtectedRoute allowedRoles={["Superadmin"]}>
              <SuperAdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="enterprize-management" element={<Enterprize />} />
          <Route path="enterprize-setting" element={<EnterpriseSettings />} />
          {/* <Route path="File-management" element={<OneDriveFileManager />} /> */}
          <Route path="performance-log" element={<PerformanceLog />} />
          <Route path="trace-logs" element={<ActivityLog />} />
          <Route path="error-logs" element={<ErrorLog />} />
          <Route path="role-management" element={<RoleManagement />} />
          <Route path="module" element={<ModuleManagement />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="model-dynamic" element={<ModelManagement />} />
          <Route path="product-management" element={<ProductManagement />} />
          <Route path="model-management" element={<Models />} />
          <Route path="version-management" element={<VersionHistory />} />
          <Route path="api-management" element={<ApiManagement />} />
          <Route path="notifications" element={<Notifications />} />
          <Route
            path="group-management"
            element={<DepartmentManagement />}
          />
          <Route
            path="conversation-management"
            element={<ConversationManagement />}
          />
          <Route
            path="chat-usage-management"
            element={<ChatUsageManagement />}
          />
          <Route
            path="user-session-management"
            element={<UserSessionManagement />}
          />
          <Route
            path="subscription-management"
            element={<SubscriptionManagement />}
          />
          <Route
            path="knowledge-repository"
            element={<SuperadminKnowledgeRepository />}
          />
          <Route
            path="knowledgerepository-weburls"
            element={<SuperadminUrlsHistory />}
          />
          <Route
            path="knowledgerepository-videourls"
            element={<SuperadminYoutubeHistory />}
          />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<UserProfileSettings />} />
          <Route path="getHelpPage" element={<HelpPage />} />

          <Route path="*" element={<ComingSoon />} />
        </Route>

        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="user-management" element={<UserManagement1 />} />
          <Route path="enterprize-setting" element={<EnterpriseSettings1 />} />
          <Route path="enterprize-managements" element={<Enterprise1 />} />
          <Route path="trace-logs" element={<ActivityLog />} />
          <Route path="performance-logs" element={<PerformanceLog />} />
          <Route path="training-files" element={<TrainingFiles />} />
          <Route path="training-text" element={<TrainingText />} />
          <Route path="training-website" element={<TrainingWebsite />} />
          <Route path="training-qa" element={<TrainingQA />} />
          <Route path="training-youtube" element={<TrainingYoutube />} />
          <Route path="uploaded-docs" element={<UploadedDocs />} />
          <Route
            path="group-management"
            element={<DepartmentManagement />}
          />
          <Route
            path="knowledge-repository"
            element={<DocumentHistory />}
          />
          <Route path="knowledge-repo-urls" element={<UrlsHistory />} />
          <Route path="knowledge-repo-text" element={<TextHistory />} />
          <Route path="knowledge-repo-qa" element={<QAHistory />} />
          <Route path="knowledge-repo-video" element={<YoutubeHistory />} />
          <Route path="repo-organizer" element={<RepoOrganizer role="admin" />} />

          <Route path="notifications" element={<Notifications />} />
          <Route path="profile" element={<UserProfileSettings />} />
          <Route
            path="conversation-management"
            element={<ConversationManagement1 />}
          />
          <Route
            path="chat-usage-management"
            element={<ChatUsageManagement1 />}
          />
          <Route
            path="user-session-management"
            element={<UserSessionManagement1 />}
          />
          <Route path="getHelpPage" element={<HelpPage />} />
        </Route>

        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route path="/chat/shared/:session_id" element={<ChatSharedPage />} />
        <Route
          path="/view-conversation/:session_id"
          element={<ViewConversation />}
        />
        <Route path="/premium-page" element={<PrimiumpPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Global Offline Spinner Overlay */}
      {isOffline && (
        <div
          className="offline-overlay d-flex align-items-center justify-content-center"
          style={{
            position: "fixed", // fixed to cover entire viewport
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            flexDirection: "column",
          }}
        >
          <div
            className="spinner-border"
            role="status"
            style={{
              width: "50px",
              height: "50px",
              color: "white",
            }}
          />
          <p className="mt-2" style={{ color: "white" }}>
            Unable to connect to the internet. Please check your connection and
            try again.
          </p>
        </div>
      )}
    </>
  );
};

const App = () => {
  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }, []);

  return (
    <Router>
      <ChatStreamProvider>
        <AppRoutes />
      </ChatStreamProvider>

      <ToastContainer
        position="top-right"
        autoClose={2500}
        closeButton={false} // We added custom close
        hideProgressBar={false}
        newestOnTop={true}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="colored"
        limit={5}
      />
    </Router>
  );
};

export default App;
